export const CREATE_FILE_REFERENCE_REQUEST = 'CREATE_FILE_REFERENCE_REQUEST';

export const createFileReferenceRequest = ( fileResourceData: any ) => ({
    type: CREATE_FILE_REFERENCE_REQUEST,
    payload: { fileResourceData },
});
